import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import blogimage1 from "./../images/blog/picforasana-640.webp";
import blogimage1Large from "./../images/blog/picforasana-1280.webp";
import blogimage2 from "./../images/blog/picforasana2-640.webp";
import blogimage2Large from "./../images/blog/picforasana2-1280.webp";
import blogimage3 from "./../images/blog/managerless-sprint-640.webp";
import blogimage3Large from "./../images/blog/managerless-sprint-1280.webp";
import blogimage4 from "./../images/blog/time-saved-kpi-640.webp"; // NEW cover
import blogimage4Large from "./../images/blog/time-saved-kpi-1280.webp";
import blogimage5 from "./../images/blog/agentic-raci-640.webp";
import blogimage5Large from "./../images/blog/agentic-raci-1280.webp";
import blogimage6 from "./../images/blog/why-project-updates-640.webp";
import blogimage6Large from "./../images/blog/why-project-updates-1280.webp";
import blogimage7 from "./../images/blog/automationdebt-640.webp"; // TODO swap to new cover later
import blogimage7Large from "./../images/blog/automationdebt-1280.webp";
import blogimage8 from "./../images/blog/decision-latency-640.webp"; // NEW cover
import blogimage8Large from "./../images/blog/decision-latency-1280.webp";
import blogimage9 from "./../images/blog/auditready-640.webp"; // NEW cover
import blogimage9Large from "./../images/blog/auditready-1280.webp";
import blogimage10 from "./../images/blog/span-of-control.svg"; // NEW cover
import blogimage11 from "./../images/blog/context-switching-tax.svg"; // NEW cover
import blogimage12 from "./../images/blog/shadow-ai-at-work.svg"; // NEW cover
import blogimage13 from "./../images/blog/onboarding-agentic-runbooks.svg"; // NEW cover
import blogimage14 from "./../images/blog/capacity-planning-ai-agents.svg"; // NEW cover
import blogimage15 from "./../images/blog/ai-agent-escalation-ladder.svg"; // NEW cover

/** Add cover + alt for each post. Put images under /public/images/blog */
const posts = [
  {
    slug: "/blog/ai-agent-escalation-ladder",
    title:
      "The Escalation Ladder: Designing When an AI Agent Should Stop and Ask a Human",
    date: "2026-10-30",
    excerpt:
      "Gartner expects over 40% of agentic AI projects to be canceled by the end of 2027, and two of the three reasons it names are design decisions. A four-rung escalation ladder, a reversibility × blast-radius test for placing any action on it, and the four metrics that tell you the ladder is set wrong.",
    cover: blogimage15,
    alt: "The AI agent escalation ladder: four rungs rising from observe to advise to act with approval to autonomous, with a stop-and-ask human gate before the top rung",
  },
  {
    slug: "/blog/capacity-planning-ai-agents",
    title: "Capacity Planning When Part of Your Team Is Software",
    date: "2026-10-19",
    excerpt:
      "74% of frontline employees now use AI regularly and 42% of them save about a workday a week, but 66% get little or no guidance on where that time should go. Here's a blended capacity model that sizes usable human hours, net agent throughput, and the review time agents create.",
    cover: blogimage14,
    alt: "Capacity planning with AI agents: a demand line above fixed human capacity bars, with an elastic metered agent capacity band closing the gap",
  },
  {
    slug: "/blog/onboarding-agentic-runbooks",
    title: "Onboarding at Speed: Agentic Runbooks vs. Tribal Knowledge",
    date: "2026-09-21",
    excerpt:
      "Only 16% of knowledge workers say their workflows are well documented, and just 4% say none of their team's work depends on asking a specific person. That gap is why new hires stall. Here's how to convert tribal knowledge into runbooks that actually execute.",
    cover: blogimage13,
    alt: "Onboarding at speed: tribal knowledge locked in colleagues' heads on the left, an executable BossDrop agentic runbook with numbered steps on the right",
  },
  {
    slug: "/blog/shadow-ai-at-work",
    title:
      "Shadow AI at Work: What Your Team Is Already Automating Without You",
    date: "2026-09-10",
    excerpt:
      "Two-thirds of office professionals have used AI at work they believed was against policy, and shadow AI now adds $670,000 to the average breach. Here's why blocking backfires, and a five-step framework to route that demand somewhere you can see.",
    cover: blogimage12,
    alt: "Shadow AI at work: a small amount of sanctioned AI use visible above the line, and a much larger volume of unapproved AI tools running below it",
  },
  {
    slug: "/blog/context-switching-tax",
    title:
      "The Context-Switching Tax: What Fragmented Attention Costs Your Team, and How Agent Handoffs Reduce It",
    date: "2026-07-30",
    excerpt:
      "Workers toggle between apps about 1,200 times a day, losing roughly four hours a week just reorienting. Here’s how to size that tax for your own team, and why agent handoffs remove switches instead of just making them faster.",
    cover: blogimage11,
    alt: "The context-switching tax: a fragmented workday of constant app toggling compared with a consolidated day coordinated by the BossDrop AI layer",
  },
  {
    slug: "/blog/span-of-control-agentic-ai",
    title:
      "Span of Control: Why Middle Management Caps Your Team—and How Agentic AI Removes the Ceiling",
    date: "2026-07-28",
    excerpt:
      "Span of control is the hidden ceiling on every team: how many people one leader can coordinate before you add a management layer. Here’s why the limit exists—and how agentic AI raises the ratio so you flatten the org instead of stacking it.",
    cover: blogimage10,
    alt: "One leader coordinating a wide team through the BossDrop AI layer, illustrating a large span of control",
  },
  {
    slug: "/blog/audit-ready-ai-agent-automation",
    title:
      "Audit-Ready Automation: How to Use AI Agents Without Losing Control",
    date: "2026-03-02",
    excerpt:
      "AI agents can shrink coordination overhead, but only if they’re governed: least-privilege access, approval gates, and audit trails. A practical playbook for safe enterprise automation.",
    cover: blogimage9,
    coverLarge: blogimage9Large,
    alt: "Audit-ready AI automation with approvals, least privilege access, and an auditable execution log",
  },
  {
    slug: "/blog/decision-latency",
    title:
      "Decision Latency: The Silent Killer of Execution - and How Agentic AI Fixes It",
    date: "2026-02-21",
    excerpt:
      "Most orgs don’t fail because they can’t build - they fail because they can’t decide. Reduce approval loops, signal drift, and escalation delays with governed agentic automation.",
    cover: blogimage8,
    coverLarge: blogimage8Large,
    alt: "Decision latency in workflows where signals get stuck in approval queues before action",
  },
  {
    slug: "/blog/automation-debt-workflow-sprawl",
    title:
      "Automation Debt: The Hidden Tax of Workflow Sprawl - and How Agentic AI Pays It Down",
    date: "2026-02-03",
    excerpt:
      "Workflow sprawl creates invisible coordination work that compounds across tools and teams. Here’s how agentic automation reduces the handoff tax - without replacing your stack.",
    cover: blogimage7,
    coverLarge: blogimage7Large,
    alt: "Workflow sprawl across tools creating automation debt in coordination",
  },
  {
    slug: "/blog/why-project-updates-still-waste-hours",
    title: "Why Project Updates Still Waste Hours - and How AI Fixes It",
    date: "2025-10-17",
    excerpt:
      "Status rituals burn time. Agent-first AI turns updates into automated, risk-aware rollups tied to your source of truth.",
    cover: blogimage6,
    coverLarge: blogimage6Large,
    alt: "AI transforming manual status updates into automated rollups",
  },
  {
    slug: "/blog/agentic-raci",
    title: "Agentic RACI: Redefining Responsibility When AI Does the Doing",
    date: "2025-10-03",
    excerpt:
      "ARACI = Agent • Responsible • Accountable • Consulted • Informed. A practical governance model for AI work management - roles, approvals, audit trails, and metrics.",
    cover: blogimage5,
    coverLarge: blogimage5Large,
    alt: "Agentic RACI matrix showing Agent, Responsible, Accountable, Consulted, Informed",
  },
  {
    slug: "/blog/the-new-kpi-time-saved-by-ai",
    title: "The New KPI: Time Saved by AI (with BossDrop)",
    date: "2025-09-22",
    excerpt:
      "Meet the metric that actually moves revenue: hours freed. How BossDrop AI proves, improves, and productizes time savings across your stack.",
    cover: blogimage4,
    coverLarge: blogimage4Large,
    alt: "Time Saved KPI dashboard in BossDrop showing hours freed by automation",
  },
  {
    slug: "/blog/managerless-sprint-bossdrop-ai-2029",
    title:
      "The Managerless Sprint (2029): How BossDrop AI Automates Middle-Manager Tasks - And What Stays Human",
    date: "2025-09-02",
    excerpt:
      "A 5-year look at AI project management: which coordination tasks vanish - and which leadership skills matter more than ever.",
    cover: blogimage3,
    coverLarge: blogimage3Large,
    alt: "BossDrop AI automating task breakdowns and scheduling",
  },
  {
    slug: "/blog/fewer-meetings-with-bossdrop-ai",
    title:
      "Fewer Meetings with BossDrop AI: Auto-Schedule by Risk, Availability, and Asana Tasks",
    date: "2025-08-25",
    excerpt:
      "Replace status meetings with async roll-ups and risk-aware scheduling. BossDrop keeps teams focused - and only schedules what truly matters.",
    cover: blogimage2,
    coverLarge: blogimage2Large,
    alt: "BossDrop AI auto-scheduling by risk and team availability",
  },
  {
    slug: "/blog/ai-project-management-with-bossdrop",
    title:
      "AI Project Management with BossDrop: Smarter Task Assignment, Fewer Meetings",
    date: "2025-08-19",
    excerpt:
      "How teams use BossDrop’s AI to plan, assign, and execute work - without the overhead of traditional management.",
    cover: blogimage1,
    coverLarge: blogimage1Large,
    alt: "Dashboard view of AI assigning tasks across a project timeline",
  },
];

/** Simple IntersectionObserver to add .is-visible to .reveal nodes */
function useRevealOnScroll() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".reveal"));
    if (!("IntersectionObserver" in window) || !els.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

export default function Blog() {
  useRevealOnScroll();

  return (
    <section className="page container">
      <SEO
        title="BossDrop | Blog"
        description="BossDrop Blog: practical AI-ops playbooks, leadership tips, and product updates to help teams ship faster with less busywork."
        canonical="https://bossdrop.ai/blog"
        url="https://bossdrop.ai/blog"
        image="https://bossdrop.ai/og/blog-1200x630.jpg"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "BossDrop Blog",
          url: "https://bossdrop.ai/blog",
          publisher: {
            "@type": "Organization",
            name: "BossDrop",
            url: "https://bossdrop.ai/",
          },
        }}
        breadcrumbsJsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://bossdrop.ai/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Blog",
              item: "https://bossdrop.ai/blog",
            },
          ],
        }}
      />

      <div className="hero reveal" style={{ "--delay": "0ms" }}>
        <h1 className="h1">BossDrop Blog</h1>
        <p className="sub">
          Insights on AI project management and autonomous work orchestration.
        </p>
      </div>

      <div className="grid cards">
        {posts.map((p, i) => (
          <article
            key={p.slug}
            className="card reveal"
            style={{ "--delay": `${100 + i * 80}ms` }}
          >
            <Link
              to={p.slug}
              className="card-media"
              aria-label={`Open: ${p.title}`}
            >
              <img
                loading="lazy"
                src={p.cover}
                srcSet={
                  p.coverLarge
                    ? `${p.cover} 640w, ${p.coverLarge} 1280w`
                    : undefined
                }
                sizes="(max-width: 900px) 92vw, 420px"
                alt={p.alt || p.title}
                width="800"
                height="450"
              />
            </Link>

            <div className="card-body">
              <h3 className="card-title">
                <Link to={p.slug}>{p.title}</Link>
              </h3>
              <div className="meta">
                {new Date(p.date).toLocaleDateString(undefined, {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })}
              </div>
              <p className="card-excerpt">{p.excerpt}</p>
              <div className="card-cta">
                <Link className="btn btnGhost" to={p.slug}>
                  Read more
                </Link>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
